import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Axios from "axios";

import AddCircleIcon from "@material-ui/icons/AddCircle";

import { useStyles } from "./AddVehicle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class AddVehicle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        route: "",
        vehicleNumber: "",
        driver: "",
        assistantDriver: "",
      },
      drivers: [],
      vehicleNumberError: "",
      driverError: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.getDrivers();
    if (this.props.vehicleId) {
      this.getVehicle(this.props.vehicleId);
    }
  }

  getDrivers = async () => {
    try {
      const response = await Axios.get(`${url}/api/drivers`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.drivers.length !== 0) {
        this.setState({ drivers: response.data.drivers });
      } else {
        this.setState({ drivers: [] });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getDrivers();
      }
    }
  };

  getVehicle = async (vehicleId) => {
    try {
      const response = await Axios.get(`${url}/api/vehicles/${vehicleId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.vehicle) {
        this.setState({
          data: {
            route: response.data.vehicle.route,
            vehicleNumber: response.data.vehicle.vehicleNumber,
            driver: response.data.vehicle.driver._id,
            assistantDriver: response.data.vehicle.assistantDriver._id,
          },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getVehicle(vehicleId);
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  checkError = (driver, vehicleNumber) => {
    let driverError = driver ? driver : "";
    let vehicleNumberError = vehicleNumber ? vehicleNumber : "";
    if (this.state.data.vehicleNumber.length < 6) {
      vehicleNumberError = "Vehicle Number must be more than 6 characters";
    }

    if (driverError || vehicleNumberError) {
      this.setState({ driverError, vehicleNumberError });
      return true;
    } else {
      this.setState({
        driverError: "",
        vehicleNumberError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        if (this.props.vehicleId) {
          this.handleUpdate(e);
        } else {
          const response = await Axios.post(
            `${url}/api/vehicles`,
            this.state.data,
            {
              headers: {
                Authorization: `Bearer ${this.props.adminToken}`,
              },
            }
          );
          if (response.data.message === "Vehicle added successfully") {
            this.props.history.push(`/administration/vehicle`);
          }
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message ===
          "Given vehicle already assigned to driver"
        ) {
          console.clear();
          this.checkError("", "The vehicle with this number already exists");
        }
        if (
          error.response.data.message ===
          "Driver is already assigned to another vehicle"
        ) {
          console.clear();
          this.checkError(
            "This driver is already assigned to next vehicle",
            ""
          );
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  handleUpdate = async (e) => {
    try {
      const response = await Axios.put(
        `${url}/api/vehicles/${this.props.vehicleId}`,
        this.state.data,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Vehicle updated successfully") {
        this.props.history.push(`/administration/vehicle`);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleUpdate(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const driverList = this.state.drivers.filter(
      (driver) => driver.category === "Driver"
    );
    const assistantDriverList = this.state.drivers.filter(
      (driver) => driver.category === "Assistant Driver"
    );
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          {this.props.vehicleId ? (
            <PageTitle title="Edit Vehicle" />
          ) : (
            <PageTitle title="Add New Vehicle" />
          )}

          <form onSubmit={this.handleSubmit}>
            <div>
              <TextField
                name="route"
                type="text"
                required
                fullWidth
                label="Route"
                variant="outlined"
                margin="normal"
                placeholder="Enter your Vechicle No"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.route}
                onChange={this.handleChange}
              />
              <TextField
                name="vehicleNumber"
                type="text"
                required
                fullWidth
                label="Vechicle Number"
                variant="outlined"
                margin="normal"
                error={this.state.vehicleNumberError ? true : false}
                helperText={this.state.vehicleNumberError}
                placeholder="Enter your Vechicle No"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.vehicleNumber}
                onChange={this.handleChange}
              />
              <div className={classes.driverInputStyle}>
                <div className={classes.inputWithMargin}>
                  <TextField
                    name="driver"
                    select
                    required
                    fullWidth
                    label="Driver"
                    variant="outlined"
                    margin="normal"
                    error={this.state.driverError ? true : false}
                    helperText={this.state.driverError}
                    SelectProps={{ native: true }}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline,
                        focused: classes.focused,
                      },
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.labelRoot,
                        focused: classes.labelFocused,
                      },
                      shrink: true,
                    }}
                    value={this.state.data.driver}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Any One</option>
                    {driverList.map((driver, index) => (
                      <option key={index} value={driver._id}>
                        {driver.driverFullName}
                      </option>
                    ))}
                  </TextField>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AddCircleIcon
                      className={classes.tooltip}
                      onClick={() =>
                        this.props.history.push(`/administration/driver/add`)
                      }
                    />
                    <div>Add drivers if not available</div>
                  </div>
                </div>

                <div className={classes.inputWithMargin}>
                  <TextField
                    name="assistantDriver"
                    select
                    fullWidth
                    label="Assistant Driver"
                    variant="outlined"
                    margin="normal"
                    SelectProps={{ native: true }}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline,
                        focused: classes.focused,
                      },
                    }}
                    InputLabelProps={{
                      classes: {
                        root: classes.labelRoot,
                        focused: classes.labelFocused,
                      },
                      shrink: true,
                    }}
                    value={this.state.data.assistantDriver}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Any One</option>
                    {assistantDriverList.map((driver, index) => (
                      <option key={index} value={driver._id}>
                        {driver.driverFullName}
                      </option>
                    ))}
                  </TextField>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AddCircleIcon
                      className={classes.tooltip}
                      onClick={() =>
                        this.props.history.push(`/administration/driver/add`)
                      }
                    />
                    <div>Add drivers if not available</div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                className={classes.buttonStyle}
              >
                {this.props.vehicleId ? "Update" : "Submit"}
              </Button>
              {this.state.loading && <FormLoader />}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddVehicle)));
